const SELECTOR_FORM = '.js-mailing-list';

export default function setupMailingList() {
  mailingListInit();
  $(document).on('turbolinks:load', mailingListInit);

  function mailingListInit() {
    $(SELECTOR_FORM)
      .attr('novalidate', '')
      .on('submit', e => {
        e.preventDefault();

        const $form = $(e.target);
        const $inputField = $form.find('input[type=email]');

        if (emailIsValid($form, $inputField)) {
          $form.find('button').attr('disabled', true);
          $.ajax({
            url: '/mailing_list',
            method: 'POST',
            dataType: 'json',
            data: {
              email: $inputField.val(),
              via: $form.attr('data-via'),
              label: $form.attr("data-label"),
              course_id: $form.attr('data-course-id'),
              segment_event: $form.attr('data-segment-event')
            },
            success: function() {
              window.analytics.track('CourseTrial');

              let successMessage =
                "You have successfully signed up to our mailing list!";
              if ($form.attr("data-via") === "course-prelaunch-page") {
                successMessage =
                  "Thanks for signing up. Keep an eye on your inbox for the latest updates.";
              } else if ($form.attr("data-course-id")) {
                successMessage =
                  "Thanks for signing up to receive your free lesson. Check your inbox - it's on the way!";
              }

              $form
                .addClass("text-center text-md-left")
                .html(
                  `<div class="bm-form-success-message">${successMessage}</div>`
                );
            },
            error: function() {
              $form
                .css('color', '#b00020')
                .addClass('text-center text-md-left')
                .append(
                  'There was an error, please refresh the page and try again'
                );
            }
          });
        }
      });
  }
}

function emailIsValid($form, $inputField) {
  const email = $inputField.val();
  if (email.length === 0) {
    renderError($form, $inputField, "Email address can't be blank");
  } else if (!email.includes('@')) {
    renderError($form, $inputField, 'Email address must include an "@"');
  } else if (email.substring(email.length - 1) == '@') {
    renderError($form, $inputField, 'Please enter a part following "@"');
  } else {
    return true;
  }
}

function renderError($form, $inputField, msg) {
  const $errorEl = $form.find('.invalid-feedback');
  $errorEl.text(msg).show();

  $inputField.addClass('is-invalid');
}
